<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>起止时间:</label>
            <timeStampDatePicker type="daterange" placeholder="请选择" v-model="query.date"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click='handleClick'>对账</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insuranceLanzhou';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'InsuranceAccountCheck',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {
        beginTime: null,
        endTime: null,
        date: [],
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '险种',
          key: 'insutypeName',
          minWidth: 116,
        },
        {
          title: '清算类别',
          key: 'clrTypeName',
          minWidth: 116,
        },
        {
          title: '结算经办机构',
          key: 'setlOptins',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '医疗费总额',
          key: 'medfeeSumamt',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '基金支付总额',
          key: 'fundPaySumamt',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '个人账户支付金额',
          key: 'acctPay',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '定点医药机构结算笔数',
          key: 'fixmedinsSetlCnt',
          minWidth: 160,
          tooltip: true,
        },
        {
          title: '对账结果',
          key: 'stmtRsltName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '对账结果说明',
          key: 'stmtRsltDscr',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {
        beginTime: null,
        endTime: null,
        date: [],
      };
    },
    handleClick() {
      this.page = 1;
      this.params.page = this.page;
      if (!this.query.date.length) {
        delete this.params.date;
        this.params.beginTime = null;
        this.params.endTime = null;
      } else {
        this.params.beginTime = this.query.date[0] || null;
        this.params.endTime = this.query.date[1] || null;
      }
      if(!this.params.beginTime || !this.params.endTime) {
        this.$Message.error('请先选择查询日期');
        return;
      }
      insurance.checkTotal(this.params).then(res => {
        if (res.data.status === 200) {
          this.tableData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.date) {
        this.params.beginTime = this.params.date[0];
        this.params.endTime = this.params.date[1];
      }
      delete this.params.date;
      if(!this.params.beginTime || !this.params.endTime) {
        this.$Message.error('请先选择查询日期');
        return;
      }
      insurance.getTotal(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 8px;
    >* {
      margin-right: 8px
    }
  }
</style>
